import {useMutation, UseMutationOptions, useQueryClient} from '@tanstack/react-query';
import coreApiClient from '@mgp-fe/shared/core-api/client.ts';
import keysResolver from '@mgp-fe/shared/core-api/keysResolver.ts';
import endpoints from '@mgp-fe/shared/core-api/endpoints.ts';
import {AxiosError, AxiosResponse} from 'axios';
import {HydraError} from '@mgp-fe/shared/core-api/domain/base.ts';

export const useVoidCartMutation = (props?: UseVoidCartMutationProps) => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationKey: keysResolver(endpoints.cart.my.void),
		mutationFn: () => coreApiClient.put<null>(endpoints.cart.my.void, {}),
		...props,
		onSuccess: async (data, variables, context) => {
			await queryClient.refetchQueries(keysResolver(endpoints.cart.my.item));
			props?.onSuccess?.(data, variables, context);
		},
	});
};


type UseVoidCartMutationProps = UseMutationOptions<
	AxiosResponse<null>,
	AxiosError<HydraError>
>;
